
export default {
  name: 'AppReviewMediaIndicator',
  props: {
    review: { type: Object, required: true },
    mediaPosition: { type: Number, required: true }
  }
};
